import { TreatmentDesign } from './treatment-design.model';
import { Treatment } from './treatment';
import { TreatmentDesignRevisionJudgement } from './treatment-design-revision-judgement';

export interface RevisionDesign {
    originDesign: TreatmentDesign;
    treatment: Treatment;
    revisionJudgement: TreatmentDesignRevisionJudgement;
    treatmentId: string;
}

export type RevisionDesigns = RevisionDesign[];
